import styled from 'styled-components';

export const hexToRgba = (hex, alpha) => {
  const value = hex.replace('#', '');
  const r = parseInt(value.substring(0, 2), 16);
  const g = parseInt(value.substring(2, 4), 16);
  const b = parseInt(value.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 80px);
  padding: 0;
  background-color: ${({ theme }) => theme.colors.background};
  overflow: hidden;
`;

export const RelatorioPeriodoVendas = styled.div`
  display: flex;
  padding: 0 16px;
`;

export const PageHeader = styled.header`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 24px;
  background-color: ${({ theme }) => theme.colors.background};
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightGrayOpacity};
  flex-shrink: 0;
`;

export const PageTitle = styled.h3`
  font-size: 24px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.text};
  margin: 0;
  white-space: nowrap;
`;

export const DashboardGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 2fr);
  gap: 12px;
  align-items: start;
  padding: 12px 24px;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`;

export const KpiCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 16px;
  border-radius: 10px;
  background-color: ${({ theme }) => theme.colors.backgroundSecondary};
  border: 1px solid ${({ theme }) => theme.colors.lightGrayOpacity};
  min-width: 0;
`;

export const KpiLabelRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const KpiIconChip = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 6px;
  flex-shrink: 0;
  color: #fff;
  background: ${({ $color }) => $color};
`;

export const KpiLabel = styled.span`
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const KpiValue = styled.span`
  font-size: 17px;
  font-weight: 700;
  color: ${({ $color, theme }) => $color || theme.colors.text};
`;

export const ChartCard = styled.div`
  padding: 16px;
  border-radius: 10px;
  background-color: ${({ theme }) => theme.colors.backgroundSecondary};
  border: 1px solid ${({ theme }) => theme.colors.lightGrayOpacity};
  min-width: 0;

  svg > g > g:last-child {
    pointer-events: none;
  }
`;

export const TableCard = styled.div`
  grid-column: span 4;
  min-width: 0;
  padding: 16px;
  border-radius: 10px;
  background-color: ${({ theme }) => theme.colors.backgroundSecondary};
  border: 1px solid ${({ theme }) => theme.colors.lightGrayOpacity};
`;

export const ChartTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
`;

export const LegendRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
  margin-top: 4px;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const LegendDot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ $color }) => $color};
`;

export const ExplorarCard = styled(ChartCard)`
  grid-column: 1 / -1;
`;

export const FiltrosExplorar = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: center;
  gap: 12px;
`;

export const Podio = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 12px;
  padding: 16px 0 8px;
`;

export const PodioColuna = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  flex: 1;
  min-width: 0;
  max-width: 220px;
`;

export const PodioNome = styled.span`
  max-width: 100%;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text};
`;

export const PodioQuantidade = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const PodioBloco = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  height: ${({ $altura }) => $altura}px;
  padding-top: 10px;
  border-radius: 10px 10px 0 0;
  font-size: 22px;
  font-weight: 700;
  color: #fff;
  background: ${({ $color }) => $color};
`;

export const PodioRestante = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 12px;
`;

export const PodioRestanteLinha = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.text};
  background: ${({ theme }) => theme.colors.lightGrayOpacity};
`;
